import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import {useTranslation} from "react-i18next";
import st from "@/styles/Home.module.scss"
import CommonClass from "@/utils/common";
import clsx from "clsx";
import {CircularProgress} from "@mui/material";
import CreditItem from "@/components/CreditItem.tsx";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import Button from "@/ui/Button.tsx";
import useLoans from "@/hooks/loans.ts";
import LazyImage from "@/ui/LazyImage.tsx";
import Images from "@/utils/images.ts";
import InfoIcon from "@/svg/InfoIcon.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CalculatorIcon from "@/svg/CalculatorIcon.tsx";
import Application from "@/components/Application.tsx";
import {useAtom} from "jotai/index";
import {pending_loans} from "@/atoms/common.ts";
import LoanApplicationTypesInterface from "@/types_and_interfaces/loan_types_interface.ts";
import HomeDashboardCalculator from "@/components/HomeDashboardCalculator.tsx";



const StandartCredit = () => {
    const {t} = useTranslation()
    const current_value = 5698
    const formated_value = CommonClass.formatMoneyAmount(current_value)
    const loans = useLoans()
    const expired_credits = loans.getExpiredLoans().filter((x) => x.product_group !== "Credit Line")
    const empty = true
    const standart_credits = loans.getStandardCredits()?.filter((x) => (x.r_status_simplified === "success" && x.r_status !== "settled"))
    const other_credits = loans.getStandardCredits()?.filter((x) => x.r_status_simplified !== "success")
    const [applications] = useAtom(pending_loans);
    const typed_appl = applications as LoanApplicationTypesInterface


    const approvedApplications = applications  && typeof typed_appl.approved !== 'undefined' ? typed_appl.approved : [];

    const restants = (standart_credits || []).filter((x) => x.loan_age > 0).sort((a, b) => b.loan_age - a.loan_age)
    const non_restants = (standart_credits || []).filter((x) => x.loan_age === 0)

    return (

        <>

            <DashboardGenComponent

                responsive1

                header_type={"primary"}

                heading={
                    <div>
                        {t("standart_credit")}

                    </div>
                }

                header_content={!empty ?
                    (
                        <div className={clsx(st.header_content, st.light)}>
                            <span>
                                {t("payment_sum")}
                            </span>

                            <div style={{justifyContent: "space-between"}} className={st.balance}>
                                <div className={st.right}>
                                    {formated_value && (
                                        <strong
                                            className={clsx(
                                                current_value < 0 && st.negative,
                                                current_value > 0 && st.positive,
                                            )}
                                        >
                                            {current_value > 0 ? "+" + formated_value : formated_value}
                                        </strong>
                                    )}
                                    {t("currency")}
                                </div>

                                <Button className={st.return_btn} outlined>
                                    {t("return")}
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className={clsx(st.header_content, st.credit_standart)}>
                            <Button light className={st.new_credit_btn} onClick={() => {
                                eventEmitter.emit(CommonClass.ModalEvents.OpenCalculator, true)
                            }}>
                                <CalculatorIcon/>
                                
                                {t("new_credit")}
                            
                            </Button>
                            
                            {(Array.isArray(standart_credits) && standart_credits.length) ? null : (
                                <LazyImage
                                    className={clsx(st.header_content_image, st.sunduc)}
                                    src={Images.common.sunduc}
                                    alt={"sunduc"}
                                />
                            )}
                        
                        </div>
                    )
                }
                
                column_center={
                    <div className={st.column_center}>


                        {Array.isArray(standart_credits) ? (
                            <>

                                {(Array.isArray(approvedApplications) && approvedApplications.length) ? (

                                    <>

                                        <strong>
                                            {t("approved_loans")}
                                        </strong>

                                        {approvedApplications?.map((app, i:number) => {

                                            return (
                                                <Application
                                                    simplified_status={
                                                        Boolean(approvedApplications.length) && "approved" || ""
                                                    }
                                                    order={i}
                                                    application={app}
                                                    key={`application_${app.id}`}
                                                />
                                            )
                                        })}
                                    </>

                                ) : null}

                                {restants.length ? (
                                    <strong>
                                        {t("restants")}
                                    </strong>
                                ) : null}

                                {restants.length ? restants.map((obj: LoanInterface, i) => {
                                    return <CreditItem obj={obj} key={`credit_restant_item_${i}`}/>
                                }) : null}


                                {non_restants.length ? (
                                    <strong>
                                        {t("active_loans")}
                                    </strong>
                                ) : null}

                                {non_restants.length ? non_restants.map((obj: LoanInterface, i) => {
                                    return <CreditItem obj={obj} key={`credit_nont_restant_item_${i}`}/>
                                }) : null}



                                {!standart_credits.length && (
                                    <div className={st.application_lack}>
                                        <InfoIcon/>
                                        {t("no_active_loans")}
                                    </div>
                                )}
                            </>
                        ) : (
                            <CircularProgress
                                sx={{
                                    display: "block",
                                    margin: "0 auto",
                                    color: "#000",
                                }}
                            />
                        )}
                        
                        
                        {expired_credits.length ? (
                            <>
                                <strong>
                                    {t("credit_history")}
                                </strong>
                                
                                {expired_credits.map((obj: LoanInterface, i) => {
                                    return <CreditItem obj={obj} key={`expired_credits_item_${i}`}/>
                                })}
                            </>
                        
                        ) : null}
                        
                        {(Array.isArray(other_credits) && other_credits.length) ? (
                            <>
                                <strong>
                                    {t("others")}
                                </strong>
                                
                                {other_credits.map((obj: LoanInterface, i) => {
                                    return <CreditItem obj={obj} key={`other_credits_item_${i}`}/>
                                })}
                            </>
                        
                        ) : null}
                    
                    </div>
                }
                column_right={
                    <>
                        {!Array.isArray(standart_credits) || (Array.isArray(standart_credits) && !standart_credits.length) ? (
                            
                            <div className={st.column_right}>
                                <HomeDashboardCalculator/>
                            </div>
                            
                            ) : null
                        }
                    </>
                }
            />
        </>
    )
}


export default StandartCredit